
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_1i2wg_eyely_19",
  "dismiss-button": "awsui_dismiss-button_1i2wg_eyely_51",
  "dismiss-button-inline": "awsui_dismiss-button-inline_1i2wg_eyely_57",
  "token-box": "awsui_token-box_1i2wg_eyely_64",
  "token-box-inline": "awsui_token-box-inline_1i2wg_eyely_64",
  "icon": "awsui_icon_1i2wg_eyely_113",
  "icon-inline": "awsui_icon-inline_1i2wg_eyely_119",
  "token-normal": "awsui_token-normal_1i2wg_eyely_124",
  "token-inline": "awsui_token-inline_1i2wg_eyely_131",
  "token-option-inline-dismissible": "awsui_token-option-inline-dismissible_1i2wg_eyely_157",
  "token-box-without-dismiss": "awsui_token-box-without-dismiss_1i2wg_eyely_180",
  "disable-padding": "awsui_disable-padding_1i2wg_eyely_204",
  "token-box-readonly": "awsui_token-box-readonly_1i2wg_eyely_211",
  "token-box-disabled": "awsui_token-box-disabled_1i2wg_eyely_212"
};
  